import { toast } from 'react-toastify';
import { DISCONNECT_ACC, FETCH_ACCOUNTS, FETCH_PERSONAL_ACCOUNT, SET_ACCOUNT_FEED, SNAPUP_DETAILS } from "../reducers/keys"
import { TOAST_ERROR, TOAST_SUCCESS } from "../utils"
import { ADD_ACCOUNT, CREATE_FEED, CREATE_POST, DISCONNECT_ACCOUNT, GET_CONNECTED_ACCOUNT, GET_NETWORKS, GET_NETWORK_INFO, HANDLE_AUTOCOMPLETE, GET_SNAPUP_DATA } from "./api"
import HttpClient from "./http-client";
import store from "../store";
import { getAllNotification } from './notificationAction';
import { getWallFeeds } from './analyticsAction';
import { GET_FEEDS } from './manageFeedsAction';

export const ACCOUNT_DISCONNECT = (obj, callBack) => {
    return (dispatch) => {
        new HttpClient().get(`${DISCONNECT_ACCOUNT}/${obj.account}/${obj.networkId}`).then(res => {
            const { response_code, resposneMessage, responseMessage } = res.data
            dispatch({ type: DISCONNECT_ACC, payload: obj.account })
            if (response_code == 200) TOAST_SUCCESS(resposneMessage ? resposneMessage : responseMessage)
            else TOAST_ERROR(resposneMessage ? resposneMessage : responseMessage)
            callBack();
        }).catch(err => {

        })
    }
}

export const createFeed = (data) => new HttpClient().post(CREATE_FEED, data);

export const addAccount = (data) => new HttpClient().post(ADD_ACCOUNT, data, { validateStatus: false })

export const SELECT_ACCOUNT = (data) => {
    return (dispatch) => {
        dispatch({ type: SET_ACCOUNT_FEED, payload: data })
    }
}


export const YOUTUBE_AUTOCOMPLETE = (searchQuery, type) => new HttpClient().post(HANDLE_AUTOCOMPLETE, { handle: searchQuery, networkId: 7, filterType: type });


export const ACTION_CLEAR_DATA = () => {
    return (dispatch) => {
        dispatch({ type: FETCH_ACCOUNTS, payload: null });
        dispatch({ type: FETCH_PERSONAL_ACCOUNT, payload: null });
        dispatch({ type: SET_ACCOUNT_FEED, payload: null });
    }
}

// onFeedCreated (optional) fires once the feed exists, before its posts are fetched - onboarding uses it to advance its progress indicator
export const createFeedAction = (data, networkId, callback, onFeedCreated) => {

    data = { ...data, productId: 4 }
    createFeed(data).then((res) => {
        const { responseCode, responseMessage, resposneMessage, response } = res.data

        const msg = responseMessage ? responseMessage : (typeof resposneMessage) == 'object' ? resposneMessage.message : resposneMessage;
        if (responseCode == 200) {
            toast.success(msg, { autoClose: 2000 });
            if (response.length > 0) {
                if (onFeedCreated) onFeedCreated();
                createPost({ feedId: response[0], networkId: networkId, wallId: data.wallId }, callback);
            }
        }
    }).catch(ex => {
        if (ex.response) {
            const { data } = ex.response;
            const { responseMessage, resposneMessage, responseCode } = data;
            const msg = responseMessage ? responseMessage : (typeof resposneMessage) == 'object' ? resposneMessage.message : resposneMessage;
            toast.error(msg, { autoClose: 2000 });
            callback(null, responseCode, msg);
        }
    })
}


export const createPost = (data, callback) => {
    const onBoarding = window.location.pathname.includes('onboarding');
    data = { ...data, isChangeTheme: onBoarding ? 1 : 0 };
    new HttpClient().post(CREATE_POST, data, { validateStatus: false }).then((response) => {
        const { responseCode, postCount, responseMessage, resposneMessage, feedText } = response.data;

        if (responseCode == 200) {
            store.dispatch(getWallFeeds(localStorage.getItem('ownerId')));
            store.dispatch(GET_FEEDS());
            if (!onBoarding) {
                store.dispatch(getAllNotification({ type: "latest", synced: 0, created: "", page: 0, perPage: 10, sortby: "message", direction: "ASC" }, true));
            }
            let countMsg = `post`;
            if (!isNaN(data.networkId) && [4, 19, 23].includes(data.networkId)) {
                countMsg = `review`;
            }

            // showing alternative msg for twitter zero post.
            if (postCount == 0 && data.networkId == 1) {
                toast.success(`Currently, there haven't been any posts in the last 7 days, but expect more coming soon!`, { autoClose: 3000 });
            } else {
                if (!(onBoarding && postCount == 0)) {
                    toast.success(`${postCount} ${countMsg}${postCount > 1 ? 's' : ''} added successfully`, { autoClose: 2000 });
                }
            }
            // show toast for google review historical posts
            if (data.networkId == 4) {
                setTimeout(() => toast.success(`If there are more reviews, they are being fetched in the background. This might take upto 1 minute.`, { autoClose: 3000 }), 1500)
            }
            setTimeout(() => callback(onBoarding ? { postCount, feedName: feedText ? feedText : '' } : data.feedId), 500)
        } else {
            const msg = responseMessage ? responseMessage : (typeof resposneMessage) == 'object' ? resposneMessage.message : resposneMessage;
            callback(null);
            toast.error(msg, { autoClose: 2000 })
        }
    }).catch(ex => {
        if (ex.response) {
            const { data } = ex.response;
            const { responseMessage, resposneMessage } = data;
            const msg = responseMessage ? responseMessage : (typeof resposneMessage) == 'object' ? resposneMessage.message : resposneMessage;
            toast.error(msg, { autoClose: 2000 });
            callback(null);
        }
    });
}

export const getConnectedAccount = (networkId) => {
    try {
        return (dispatch) => {
            new HttpClient().get(`${GET_CONNECTED_ACCOUNT}/${networkId}`).then(res => {
                const { data } = res;

                if (data.responseCode == 200) {
                    if (networkId == 2 || networkId == 27) {
                        dispatch({ type: FETCH_PERSONAL_ACCOUNT, payload: data.accountInformations })
                    }
                    else dispatch({ type: FETCH_ACCOUNTS, payload: data.accountInformations })
                }
            })
        }
    } catch (error) {

    }

}

export const getNetworkInfoById = (networkId) => {
    const { wallData } = store.getState().wallData;
    const wallId = (wallData && Object.keys(wallData).length > 0) ? wallData.wallId : localStorage.getItem('wallId');
    return new HttpClient().get(`${GET_NETWORK_INFO}/${networkId}/${wallId}`)
}

export const getNetworks = () => new HttpClient().post(GET_NETWORKS, { wallId: localStorage.getItem('wallId'), type: 4 });



export const GET_SNAPUP_DETAILS = (obj, callBack) => {
    return async (dispatch) => {
        try {
            const { data: { responseCode, responseData, responseMessage } } = await new HttpClient().get(`${GET_SNAPUP_DATA}/${localStorage.getItem('wallId')}`);
            if (responseCode === 200) dispatch({ type: SNAPUP_DETAILS, payload: responseData })
        } catch (error) {
            console.error("Error in GET_SNAPUP_DETAILS:", error);
        }
    };
};